/** @jsxImportSource @emotion/react */

import { Alert } from '@zip/business-components';
import { useAuth0, useMerchantData, useSnackbar } from 'contexts';
import { MfaEnrollmentStatus, PageAction } from 'enums';
import { useEffect, useState } from 'react';
import { logEvent, useMfaFunctions } from 'utils';
import { withMfaFeatureFlag } from '../high-order-components';
import * as styles from './CompleteMfa.styles';

function CompleteMfaBannerModule({
  adminOnly,
}: {
  adminOnly?: boolean;
}): JSX.Element {
  const { logout } = useAuth0();
  const Snackbar = useSnackbar();
  const { acceptMfaAsync } = useMfaFunctions();

  const { isAdmin, currentUserMfaEnrollmentStatus } = useMerchantData();
  const handleClick = async (): Promise<void> => {
    logEvent(PageAction.mfaCompleteBannerClick, {
      method: 'complete-mfa-banner',
    });
    try {
      await acceptMfaAsync();
      logout();
    } catch (err) {
      Snackbar.error('Something went wrong');
    }
  };

  const [shouldAlert, setShouldAlert] = useState<boolean>(false);
  const alertingStates = [MfaEnrollmentStatus.Invited];

  useEffect(() => {
    const inAlertingState = alertingStates.includes(
      currentUserMfaEnrollmentStatus
    );

    const shouldAlert = adminOnly
      ? isAdmin && inAlertingState
      : inAlertingState;

    setShouldAlert(shouldAlert);
  }, [currentUserMfaEnrollmentStatus]);

  return (
    shouldAlert && (
      <Alert
        variant="warning"
        data-testid="complete-mfa-alert"
        css={styles.completeMfaBanner}
      >
        <p css={styles.completeMfaBannerText} onClick={handleClick}>
          Complete your 2-step verification setup
        </p>
      </Alert>
    )
  );
}

export default withMfaFeatureFlag(CompleteMfaBannerModule);
